module.exports = "/_next/static/images/monitor-d10e5719968da94475a9c727b0b2d4dd.png.webp";